/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RequestCancelInboundPlanRequest } from './RequestCancelInboundPlanRequest';
import {
    RequestCancelInboundPlanRequestFromJSON,
    RequestCancelInboundPlanRequestFromJSONTyped,
    RequestCancelInboundPlanRequestToJSON,
    RequestCancelInboundPlanRequestToJSONTyped,
} from './RequestCancelInboundPlanRequest';

/**
 * 
 * @export
 * @interface RequestCancelInboundPlansRequest
 */
export interface RequestCancelInboundPlansRequest {
    /**
     * 
     * @type {Array<RequestCancelInboundPlanRequest>}
     * @memberof RequestCancelInboundPlansRequest
     */
    plans: Array<RequestCancelInboundPlanRequest>;
    /**
     * 
     * @type {number}
     * @memberof RequestCancelInboundPlansRequest
     */
    updateUserId: number;
}

/**
 * Check if a given object implements the RequestCancelInboundPlansRequest interface.
 */
export function instanceOfRequestCancelInboundPlansRequest(value: object): value is RequestCancelInboundPlansRequest {
    if (!('plans' in value) || value['plans'] === undefined) return false;
    if (!('updateUserId' in value) || value['updateUserId'] === undefined) return false;
    return true;
}

export function RequestCancelInboundPlansRequestFromJSON(json: any): RequestCancelInboundPlansRequest {
    return RequestCancelInboundPlansRequestFromJSONTyped(json, false);
}

export function RequestCancelInboundPlansRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestCancelInboundPlansRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'plans': ((json['plans'] as Array<any>).map(RequestCancelInboundPlanRequestFromJSON)),
        'updateUserId': json['update_user_id'],
    };
}

export function RequestCancelInboundPlansRequestToJSON(json: any): RequestCancelInboundPlansRequest {
    return RequestCancelInboundPlansRequestToJSONTyped(json, false);
}

export function RequestCancelInboundPlansRequestToJSONTyped(value?: RequestCancelInboundPlansRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plans': ((value['plans'] as Array<any>).map(RequestCancelInboundPlanRequestToJSON)),
        'update_user_id': value['updateUserId'],
    };
}

